import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BulkExportEntityService } from '@app/modules/reporting/services';
import { BULK_EXPORT_META_DATA } from '@reporting/views/bulk-export/bulk-export-config';
import { NotifyService } from 'app/services/index';

@Component({
    templateUrl: './bulk-export-entity.view.html',
    styleUrls: ['./bulk-export-entity.style.scss'],
})
export class BulkExportEntityView implements OnInit {
    /**
     * Loading Indicator
     */
    isLoading = true;

    /**
     * Processing Indicator
     */
    isProcessing = false;

    /**
     * The file id of the uploaded import csv
     */
    fileId: number;

    /**
     * The entity to be exported
     */
    entity;

    readonly importMetaData = BULK_EXPORT_META_DATA;

    constructor(
        private activatedRoute: ActivatedRoute,
        private notify: NotifyService,
        private exportService: BulkExportEntityService
    ) {}

    ngOnInit(): void {
        this.setEntityFromRoute();
        this.isLoading = false;
    }

    async onExport(): Promise<void> {
        this.isLoading = true;
        await this.exportService.export();
        this.isLoading = false;
    }

    private setEntityFromRoute(): void {
        this.entity = this.importMetaData.find(
            (entity) => entity.routerLink === this.activatedRoute.snapshot.params.entity
        );
        if (!this.entity) {
            this.notifyError();
            return;
        }
        this.exportService.entity = this.entity;
    }

    private notifyError(): void {
        this.notify.error('reporting.data-export.couldNotFindTheImportTemplate');
    }
}
